export default {
  reservations: 'Rezerwacje',
  activated: 'Aktywowane',
  deactivated: 'Dezaktywowane',
  reservations_deactivated: 'Rezerwacje są dezaktywowane.',
  tabs: {
    general: 'Ogólne',
    information: 'Informacje',
  },
  sections: {
    notifications_confirmation: 'Powiadomienia i potwierdzenia',
    notifications_confirmation_description: 'Jak goście rezerwują i jak otrzymujesz powiadomienia.',
    who_can_book: 'Kto może rezerwować',
    who_can_book_description: 'Limity liczby osób przy rezerwacjach online.',
    when_how_bookings_work: 'Kiedy i jak działają rezerwacje',
    when_how_bookings_work_description:
      'Reguły dotyczące czasu, czasu trwania i pojemności decydujące o dostępnych terminach.',
  },
  google: {
    label: 'Wyświetlaj rezerwacje w Google',
  },
  storefront: {
    label: 'Wyświetlaj rezerwacje w witrynie',
  },
  auto_confirm: {
    label: 'Automatycznie potwierdzaj rezerwacje',
  },
  email: {
    label: 'E-mail dla przychodzących rezerwacji',
    add: 'Dodaj e-mail',
    placeholder: 'Wpisz e-mail',
    required: 'Dodaj co najmniej jeden adres e-mail, aby otrzymywać nowe rezerwacje.',
    invalid: 'Wprowadź prawidłowy adres e-mail.',
  },
  has_whatsapp_phone_number: {
    label: 'Wysyłaj powiadomienia przez WhatsApp',
  },
  whatsapp_phone_number: {
    label: 'Numer WhatsApp',
    add: 'Dodaj numer telefonu',
  },
  party_size: {
    label: 'Dozwolona liczba osób na rezerwację',
    min_label: 'Min',
    max_label: 'Maks',
    to: 'do',
    guests: 'gości',
    helper:
      'Określa minimalną i maksymalną wielkość rezerwacji. Gość może zarezerwować tylko dla liczby osób z tego zakresu.',
    warning:
      'Google akceptuje rezerwacje dla 2–16 gości. Rezerwacje poza tym zakresem nadal będą działać w Twojej witrynie, ale nie pojawią się w Google.',
    warning_min: 'Google zaleca minimum 2 gości przy rezerwacjach.',
    warning_max: 'Google zaleca maksymalnie 16 gości przy rezerwacjach.',
    min_note: 'Google nie będzie oferować rezerwacji dla grup mniejszych niż {{count}} osób.',
  },
  time_slot: {
    label: 'Interwał rezerwacji',
    helper: 'Goście mogą rezerwować w krokach co tyle minut.',
    extra: 'np. {{example}}',
  },
  reservation_gap: {
    label: 'Ostatni moment rezerwacji przed zamknięciem',
    helper: 'Najpóźniejszy czas rozpoczęcia rezerwacji, liczony wstecz od godziny zamknięcia.',
    helper_link: 'Zobacz godziny rezerwacji',
    extra: 'np. zamknięcie o 22:00, cutoff {{example}} min → ostatni możliwy start o {{example}}',
  },
  reservation_notice_period: {
    label: 'Minimalny czas wyprzedzenia',
    helper: 'Najwcześniej, kiedy gość może zarezerwować przed przyjściem.',
    extra: 'np. rezerwacja do {{example}} na przyjście o 18:00',
  },
  opening_times: {
    label: 'Godziny otwarcia',
  },
  total_seats: {
    label: 'Łączna pojemność restauracji',
    helper:
      'Maksymalna liczba gości (nie stolików), którzy mogą siedzieć jednocześnie. Licz miejsca — np. 5 stolików po 4 = 20.',
  },
  capacity_explainer: {
    title: 'Jak działa pojemność',
    body: 'To liczba gości, których możesz jednocześnie obsadzić. Każda rezerwacja blokuje miejsca na czas jej trwania, po czym zwalnia je dla kolejnych gości. System pilnuje, aby zawsze było wystarczająco miejsca dla zarezerwowanych gości.',
    body_example:
      'Przykład: przy 20 miejscach możesz przyjąć rezerwację na 12 gości o 19:00 i 10 gości o 21:00, ponieważ miejsca pierwszej grupy zwalniają się przed przyjściem następnej.',
  },
  note: {
    label: 'Notatka',
  },
  grace_period: {
    label: 'Okres karencji',
    helper: 'Jak długo stolik jest trzymany po czasie rozpoczęcia rezerwacji.',
    tooltip:
      'Dodatkowy bufor po zakończeniu rezerwacji, zanim stolik zostanie ponownie udostępniony (np. na sprzątnięcie i przygotowanie stolika).',
    extra: 'np. trzymany do {{example}} dla rezerwacji o 18:00',
    placeholder: 'Wpisz okres karencji',
  },
  information: {
    rules: {
      label: 'Twój stolik będzie zarezerwowany przez:',
      add: 'Dodaj',
    },
  },
  reservation_duration: {
    label: 'Czas trwania rezerwacji',
    helper: 'Jak długo stolik jest blokowany na jedną rezerwację.',
    tooltip:
      'Jak długo stolik jest blokowany dla danej rezerwacji. Służy do obliczenia, kiedy stolik jest znów dostępny dla kolejnego gościa.',
    extra: 'np. 18:00 – {{example}}',
    minutes: '{{ count }} minut',
    hour_one: '{{ count }} godzina',
    hour_few: '{{ count }} godziny',
    hour_many: '{{ count }} godzin',
    hour_other: '{{ count }} godziny',
  },
  buttons: {
    save: 'Zapisz',
    activate: 'Aktywuj',
    deactivate: 'Dezaktywuj',
  },
  success_messages: {
    updated: 'Aktualizacja zakończona sukcesem',
    saving_successful:
      'Aktualizacja zakończona sukcesem. Pamiętaj, że Google może potrzebować do 24 godzin na uwzględnienie zmian.',
  },
  error_messages: {
    invalid_phone_number: 'Nieprawidłowy numer telefonu',
    saving_unsuccessful: 'Błąd podczas zapisywania zmian. Spróbuj ponownie.',
    enter_correct_email: 'Proszę podać poprawny adres e-mail.',
  },
};
